module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-05.572dc3f3.jpg";